import React, { useState } from 'react';
import axios from 'axios';
import './UploadProductFormDash.css';

const UploadProductFormDash = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [moreinfo, setMoreinfo] = useState('');
  const [images, setImages] = useState([]);
  const [link, setLink] = useState('');
  const [selectedCategories, setSelectedCategories] = useState(['']);


  const allCategories = [
  'מערכות מולטימדיה',
  'סטריאו לרכב',
  'ניקיון וטיפוח',
  'גגונים מנשאים',
  'מוצרי חשמל למונית ולרכב',
  'טקסטיל לרכב ולמונית',
  'ריפוד למונית ולרכב',
  'אביזרים למונית ולרכב'
];


  const handleImageChange = (e) => {
    setImages([...e.target.files]);
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  const formData = new FormData();

  formData.append('name', name);
  formData.append('description', description);
  formData.append('price', price);
  formData.append('moreinfo', moreinfo);
  formData.append('link', link);
  formData.append('categories', JSON.stringify(selectedCategories.filter(cat => cat)));
  images.forEach((img) => {
    formData.append('images', img);
  });

  try {
    const res = await axios.post('/api/products/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    alert('✔ המוצר הועלה בהצלחה');
    console.log(res.data);
  } catch (err) {
    console.error('❌ שגיאה בהעלאת מוצר:', err);
    alert('שגיאה בהעלאת המוצר');
  }
};


  return (
    <div className="upload-form-container">
      <h2 className="upload-form-title">העלה מוצר חדש</h2>
      <form onSubmit={handleSubmit} className="upload-form" encType="multipart/form-data">
        <input
          className="upload-form-input-name"
          type="text"
          placeholder="שם המוצר"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <textarea
          className="upload-form-textarea-description"
          placeholder="תיאור"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
        />
        <input
          className="upload-form-input-price"
          type="number"
          placeholder="מחיר"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          required
        />
        <textarea
          className="upload-form-textarea-moreinfo"
          placeholder="מידע נוסף"
          value={moreinfo}
          onChange={(e) => setMoreinfo(e.target.value)}
        />
        <input
          className="upload-form-input-images"
          type="file"
          multiple
          accept="image/*"
          onChange={handleImageChange}
        />
        <input
  className="upload-form-input-link"
  type="text"
  placeholder="קישור למוצר"
  value={link}
  onChange={(e) => setLink(e.target.value)}
/>
<div className="upload-form-categories">
  <label>קטגוריות:</label>
  {selectedCategories.map((cat, index) => (
    <div key={index} style={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
      <select
        value={cat}
        onChange={(e) => {
          const newCats = [...selectedCategories];
          newCats[index] = e.target.value;
          setSelectedCategories(newCats);
        }}
      >
        <option value="">בחר קטגוריה</option>
        {allCategories.map((c) => (
          <option key={c} value={c}>{c}</option>
        ))}
      </select>
      <button
        type="button"
        onClick={() => {
          const newCats = [...selectedCategories];
          newCats.splice(index, 1);
          setSelectedCategories(newCats);
        }}
      >❌</button>
    </div>
  ))}
  <button type="button" onClick={() => setSelectedCategories([...selectedCategories, ''])}>
    ➕ הוסף קטגוריה
  </button>
</div>


        <button className="upload-form-submit-button" type="submit">🚀 שלח מוצר</button>
      </form>
    </div>
  );
};

export default UploadProductFormDash;
